import styled from "styled-components";
import { COLORS } from "../../../../layout/theme";
import { Input, Table } from "antd";

export const Inner = styled.div`
	padding: 20px 10px;
`;
export const AntdTable = styled(Table)`
  .ant-table-thead > tr > th {
    background: ${COLORS.Primary};
  }

  .ant-table-row {
    background: ${COLORS.White};
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: ${COLORS.Primary};

    div {
      color: ${COLORS.Primary};
    }
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-radius: 20px 0 0 0;
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-radius: 0 20px 0 0;
  }

  }
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TableContainer = styled.div`
	.ant-table table {
		background-color: ${COLORS.LightGrey} !important;
	}
`;

export const CompaginationDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	margin-top: 18px;

	.ant-btn {
		width: 34px;
		height: 34px;
		border-radius: 999px;
		border: 1px solid #d1d5db;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: none;
	}
`;

export const AntdInput = styled(Input)`
	.ant-input-group .ant-input {
		height: 30px;
		border: 1px solid #cbd5e1;
		border-radius: 12px 0 0 12px;
		background-color: ${COLORS.White};
		text-align: center;
		padding: 5px 8px;
		font-weight: 600;
		color: #334155;
	}

	.ant-input-group .ant-input:hover,
	.ant-input-group .ant-input:focus {
		border: 1px solid #4f46e5;
		box-shadow: none;
	}

	.ant-input-group-addon {
		border: 1px solid #cbd5e1;
		border-left: 0;
		background-color: ${COLORS.White};
		padding: 0 10px;
		border-radius: 0 12px 12px 0;
		color: #64748b;
		font-weight: 600;
	}
`;

export const Circle = styled.div`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${(props) => props.color || "#ccc"};
`;

export const CardContainer = styled.div`
	min-height: 500px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const Container = styled.div`
	display: flex;
	padding: 20px;
	align-items: center;
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;

	.ant-picker,
	.ant-select-selector {
		height: 32px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item,
	.ant-picker-input input {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const InboxShell = styled.div`
	display: grid;
	grid-template-columns: 420px minmax(0, 1fr);
	height: calc(100vh - 250px);
	min-height: 640px;
	border: 1px solid #d7dbd6;
	border-radius: 18px;
	overflow: hidden;
	background: #f0f2f5;
	box-shadow: 0 14px 40px rgba(15, 23, 42, 0.08);

	@media only screen and (max-width: 900px) {
		grid-template-columns: 1fr;
		height: auto;
		min-height: 0;
	}
`;

export const ContactListPanel = styled.div`
	display: flex;
	min-width: 0;
	min-height: 0;
	flex-direction: column;
	background: #ffffff;
	border-right: 1px solid #dde2de;

	.contacts-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		padding: 16px;
		background: #f0f2f5;
		border-bottom: 1px solid #dde2de;
	}

	.contacts-title {
		display: flex;
		flex-direction: column;
	}

	.contacts-list {
		flex: 1;
		min-height: 0;
		overflow-y: auto;
	}

	.ant-list-item {
		border: 0;
		padding: 0;
	}

	@media only screen and (max-width: 900px) {
		max-height: 460px;
		border-right: 0;
		border-bottom: 1px solid #dde2de;
	}
`;

export const ContactRow = styled.div`
	display: flex;
	gap: 10px;
	cursor: ${(props) => (props.$isDisabled ? "not-allowed" : "pointer")};
	padding: 13px 14px;
	border-bottom: 1px solid #eef1ef;
	background: ${(props) => (props.$isSelected ? "#e9edef" : "#ffffff")};
	opacity: ${(props) => (props.$isDisabled ? 0.62 : 1)};
	transition: background 0.16s ease;

	&:hover {
		background: ${(props) => (props.$isSelected ? "#e9edef" : "#f5f7f7")};
	}

	.contact-select {
		padding-top: 3px;
	}

	.contact-body {
		min-width: 0;
		flex: 1;
	}

	.contact-top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		margin-bottom: 3px;
	}

	.contact-time {
		flex: 0 0 auto;
		font-size: 11px;
	}

	.contact-meta {
		display: block;
		max-width: 100%;
		font-size: 12px;
		color: #8696a0;
	}

	.contact-preview {
		margin: 5px 0 8px;
		max-width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 13px;
		color: #667781;
	}
`;

export const ConversationSidebar = styled.div`
	display: flex;
	min-width: 0;
	flex-direction: column;
	background: #ffffff;
	border-right: 1px solid #dde2de;

	.ant-list {
		overflow-y: auto;
		padding: 0;
	}

	.ant-spin-nested-loading,
	.ant-spin-container {
		min-height: 0;
	}

	@media only screen and (max-width: 900px) {
		max-height: 360px;
		border-right: 0;
		border-bottom: 1px solid #dde2de;
	}
`;

export const SidebarHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 16px;
	background: #f0f2f5;
	border-bottom: 1px solid #dde2de;
`;

export const ConversationRow = styled.div`
	cursor: pointer;
	padding: 14px 16px;
	border-bottom: 1px solid #eef1ef;
	background: ${(props) => (props.$isSelected ? "#e9edef" : "#ffffff")};
	transition:
		background 0.16s ease,
		box-shadow 0.16s ease;

	&:hover {
		background: ${(props) => (props.$isSelected ? "#e9edef" : "#f5f7f7")};
	}

	.row-top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		margin-bottom: 4px;
	}

	.time {
		flex: 0 0 auto;
		font-size: 11px;
	}

	.row-preview {
		margin-bottom: 8px;
		max-width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 13px;
		color: #667781;
	}

	.human-meta {
		margin-top: 6px;
		font-size: 11px;
		color: #8a5a00;
	}

	.pdv-name {
		display: block;
		margin-bottom: 5px;
		font-size: 12px;
		color: #8696a0;
	}
`;

export const ChatPanel = styled.div`
	display: flex;
	min-width: 0;
	min-height: 0;
	flex-direction: column;
	background: #efeae2;
	background-image:
		radial-gradient(
			circle at 20% 20%,
			rgba(255, 255, 255, 0.28) 0 2px,
			transparent 3px
		),
		radial-gradient(
			circle at 70% 60%,
			rgba(255, 255, 255, 0.22) 0 2px,
			transparent 3px
		);
	background-size: 34px 34px;
`;

export const ChatHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 14px;
	padding: 13px 16px;
	background: #f0f2f5;
	border-bottom: 1px solid #dde2de;

	@media only screen and (max-width: 700px) {
		align-items: flex-start;
		flex-direction: column;
	}
`;

export const ChatHeaderMeta = styled.div`
	display: flex;
	min-width: 0;
	flex-direction: column;
	gap: 5px;
`;

export const ControlBadge = styled.span`
	display: inline-flex;
	align-items: center;
	height: 22px;
	padding: 0 9px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 700;
	line-height: 1;
	color: ${(props) => (props.$mode === "Human" ? "#7a3f00" : "#155e75")};
	background: ${(props) => (props.$mode === "Human" ? "#ffedd5" : "#e0f2fe")};
	border: 1px solid
		${(props) => (props.$mode === "Human" ? "#fdba74" : "#7dd3fc")};
`;

export const MessagesViewport = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding: 18px 22px 10px;

	.older-messages-action {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
		margin: 0 auto 14px;
	}

	.older-messages-action .ant-btn {
		border-radius: 999px;
		box-shadow: 0 1px 1px rgba(11, 20, 26, 0.08);
	}

	.ant-list-item {
		border: 0;
		padding: 0;
	}
`;

export const PanelPagination = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	flex: 0 0 auto;
	padding: 9px 12px;
	background: rgba(240, 242, 245, 0.92);
	border-top: 1px solid #dde2de;

	.ant-btn {
		width: 30px;
		height: 30px;
		border-radius: 999px;
	}
`;

export const HistoryModalBody = styled.div`
	display: flex;
	flex-direction: column;
	height: min(70vh, 620px);
	min-height: 360px;
`;

export const HistoryListViewport = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	border: 1px solid #eef1ef;
	border-radius: 12px;

	.ant-list-item {
		border: 0;
		padding: 0;
	}
`;

export const HistoryPagination = styled(PanelPagination)`
	margin-top: 10px;
	border: 0;
	background: #ffffff;
`;

export const MessageBubble = styled.div`
	width: fit-content;
	max-width: min(74%, 620px);
	margin: ${(props) =>
		props.$side === "right" ? "0 0 10px auto" : "0 auto 10px 0"};
	padding: 8px 10px 7px;
	border-radius: ${(props) =>
		props.$side === "right" ? "12px 4px 12px 12px" : "4px 12px 12px 12px"};
	background: ${(props) => {
		if (props.$source === "Human") return "#d9fdd3";
		if (props.$source === "Agent") return "#e7f7df";
		return "#ffffff";
	}};
	box-shadow: 0 1px 1px rgba(11, 20, 26, 0.13);
	color: #111b21;
	white-space: pre-wrap;
	word-break: break-word;

	.bubble-content {
		font-size: 14px;
		line-height: 1.45;
	}

	@media only screen and (max-width: 700px) {
		max-width: 90%;
	}
`;

export const MessageMeta = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 14px;
	margin-bottom: 3px;
	font-size: 11px;
	color: #667781;

	strong {
		color: #3b4a54;
		font-size: 11px;
	}

	span {
		white-space: nowrap;
	}
`;

export const TimelineEvent = styled.div`
	display: flex;
	width: fit-content;
	max-width: 78%;
	flex-direction: column;
	align-items: center;
	gap: 2px;
	margin: 10px auto;
	padding: 6px 11px;
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.76);
	box-shadow: 0 1px 1px rgba(11, 20, 26, 0.08);
	color: #667781;
	font-size: 12px;
	text-align: center;

	small {
		font-size: 10px;
		color: #8696a0;
	}
`;

export const ComposerBar = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 12px 16px;
	background: #f0f2f5;
	border-top: 1px solid #dde2de;

	.ant-input {
		border-radius: 18px;
		border: 0;
		padding: 9px 14px;
		box-shadow: none;
		resize: none;
	}

	.ant-btn-primary {
		background: #00a884;
		border-color: #00a884;
	}

	${(props) =>
		props.$disabled
			? `
				justify-content: center;
				color: #667781;
			`
			: ""}
`;
